import { render, staticRenderFns } from "./IndexFlowerRoll.vue?vue&type=template&id=85f9c3ae&scoped=true&"
import script from "./IndexFlowerRoll.vue?vue&type=script&lang=js&"
export * from "./IndexFlowerRoll.vue?vue&type=script&lang=js&"
import style0 from "./IndexFlowerRoll.vue?vue&type=style&index=0&id=85f9c3ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f9c3ae",
  null
  
)

export default component.exports